<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/OEBPS/pppmaddog006#maintoc">Epigraph</a></p>
<br class="calibre1"/>
<br class="calibre1"/>
<p class="epf">Mad dogs and Englishmen<br class="calibre1"/>go out in the mid-day sun…</p>
<p class="ept">—Noel Coward<br class="calibre1"/>Mad Dogs and Englishmen</p>
<br class="calibre1"/>
<br class="calibre1"/>
<p class="epf">An artificial intercontinental flight vehicle does not impress someone whose hematasooma (soul) is capable of superluminal intergalactic space travel.</p>
<p class="ept">—Karl H. Schlesier</p>
<br class="calibre1"/>
<br class="calibre1"/>
<p class="epf">The Wolves of Heaven: Cheyenne Shamanism, Ceremonies, and Prehistoric Origins<br class="calibre1"/>Oh, you can’t go back to Kansas,<br class="calibre1"/>It just up and blew away…<br class="calibre1"/>…you can’t go back to Kansas,<br class="calibre1"/>’cause that was yesterday.</p>
<p class="ept">—John Stewart<br class="calibre1"/>“Kansas,” The Phoenix Concerts</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-maddog005.vue?7bf4cde4